/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "redux";
import landingReducer from "containers/LandingPage/reducer";
import invoiceReducer from "containers/InvoiceDetail/reducer";
import gstinUploadReducer from "containers/GSTINValidation/UploadPage/reducer";
import trackReturnReducer from "containers/GSTINValidation/TrackReturn/reducer";
import vendorMasterReducer from "containers/GSTINValidation/VendorMaster/reducer";
import uploadReducer from "containers/eInv/UploadPage/reducer";
import uploadB2CReducer from "containers/eInv/UploadPageB2C/reducer";
import uploadEInvoiceReducer from "containers/eInv/NewUploadPage/reducer";
import newB2CInvoiceReducer from "containers/B2C/NewB2CInvoices/reducer";
import B2CuploadReducer from "containers/B2C/NewUploadPage/reducer";
import loginReducer from "containers/LoginPage/reducer";
import failedReducer from "containers/eInv/FailedInvoice/reducer";
import processedReducer from "containers/eInv/ProcessedInvoice/reducer";
import consolidateReducer from "containers/eInv/ConsolidateInvoice/reducer";
import progressReducer from "containers/eInv/UploadProgress/reducer";
import reportsReducer from "containers/eInv/Reports/reducer";
import uploadedDataReducer from "containers/anx1/UploadedData/reducer";
import uploadedDataReducergstr9 from "containers/gstr9/UploadedData/reducer";
import prepareReducergstr9c from "containers/gstr9C/PrepareGSTR9C/reducer";
import saveReducergstr9c from "containers/gstr9C/SaveGSTR9C/reducer";
import failedAnx1Reducer from "containers/anx1/FailedAnx1/reducer";
import dataFetchReducer from "containers/anx1/DataFetch/reducer";
import reconciliationReducer from "containers/anx1/Reconciliation/reducer";
import gatr2aFileProgressReducer from "containers/anx1/FileProgress/reducer";
import gatr2aPendinInvoicesReducer from "containers/anx1/PendingInvoices/reducer";
// import gatr2aPurchaseSummaryReducer from "containers/anx1/PurchaseSummary/reducer";
// import gatr2bUpdateReducer from "containers/anx1/GSTR2B/reducer";
import gstr2aUploadReducer from "containers/anx1/UploadAnx1/reducer";
import logoutReducer from "containers/Logout/reducer";
import ewaybillReducer from "containers/eInv/EwayBill/reducer";
import scheduleReducer from "containers/eInv/ScheduleProgress/reducer";
import uploadEwayBillReducer from "containers/ewaybill/UploadPage/reducer";
import ewayBillGetReducer from "containers/ewaybill/EwayBillPartB/reducer";
import consolidateGetReducer from "containers/ewaybill/EwayBillConsolidate/reducer";
import ewayBillGetCallReducer from "containers/ewaybill/EwayBillGet/reducer";
import gstr1UploadReducer from "containers/gstr1/UploadPage/reducer";
import previewAndSubmitReducer from "containers/gstr1/PreviewAndSubmit/reducer";
import saveGstr1Reducer from "containers/gstr1/SaveGstr1/reducer";
import saveGstr9Reducer from "./containers/gstr9/SaveGstr9/reducer";
import previewAndSubmitR3BReducer from "containers/gstr3b/PreviewAndSubmit/reducer";
import uploadGstr3bReducer from "containers/gstr3b/UploadPage/reducer";
import uploadGstr9Reducer from "containers/gstr9/UploadPage/reducer";
import summaryReducer from "containers/gstr1/Summary/reducer";
import gstr1ProgressReducer from "containers/gstr1/ProgressPage/reducer";
// import gstr1InvoiceProgressReducer from 'containers/gstr1/UploadProgress/reducer';
import gstr3bFileProgressReducer from "containers/gstr3b/FileProgressPage/reducer";
import gstr3bProgressReducer from "containers/gstr3b/ProgressPage/reducer";
import SavePageGSTR3BReducer from "containers/gstr3b/SavePage/reducer"
import gstr6UploadReducer from "containers/gstr6/DataUpload/reducer";
import gstr6ViewReducer from "containers/gstr6/View/reducer";
import gstr6TabReducer from "containers/gstr6/gstr6Tab/reducer";
import gstr6aReducer from "containers/gstr6/gstr6a/reducer";
import gstr6ISDDetailsReducer from "containers/gstr6/ISDdetails/reducer";
import gstr6CommonReducer from "containers/gstr6/reducer";
import gstr3bCommonReducer from "containers/gstr3b/Gstr3bFilterComponent/reducer"
import gstr7UploadReducer from "containers/gstr7/DataUpload/reducer";
import gstr7SummaryReducer from "containers/gstr7/GSTR7Summary/reducer";
import gstr7FileDataReducer from "containers/gstr7/FileGSTR7/reducer";
import gstr7CashBalanceReducer from "containers/gstr7/CashBalance/reducer";
import gstr8UploadReducer from "containers/gstr8/DataUpload/reducer";
import gstr8CashBalanceReducer from "containers/gstr8/CashBalance/reducer";
import gstr8FileDataReducer from "containers/gstr8/FileGSTR8/reducer";
import gstr8PrepareDataReducer from "containers/gstr8/Prepare&Save/reducer";


import userManagementReducer from "containers/Admin/UserManagement/reducer";
import managePincodeReducer from "containers/Admin/ManagePincode/reducer";
import manageHsncodeReducer from "containers/Admin/ManageHsncode/reducer";
import userModuleReducer from "containers/Admin/UserModules/reducer";
import profileManagementReducer from "containers/Admin/Profile/reducer";
import manageModuleReducer from "containers/Admin/ManageModules/reducer";
import managePassInvReducer from "containers/Admin/ManagePassInv/reducer";
import manageCompanyReducer from "containers/Admin/ManageCompanies/reducer";
import managePartnerReducer from "containers/Admin/ManagePartner/reducer";
import manageGroupsReducer from "containers/Admin/ManageGroup/reducer";
import adminReportReducer from "containers/Admin/Report/reducer";
import adminAPIReportReducer from "containers/Admin/ApiReport/reducer";
import adminGSTINReportReducer from "containers/Admin/GstinReport/reducer";
import gstrSupplierInfoReducer from "containers/SupplierInfo/reducer";
import profileReducer from "containers/ProfilePage/reducer";
import { loadingBarReducer } from "react-redux-loading-bar";
import { reducer as formReducer } from "redux-form";
// import dataAnalyticsReducer from "containers/DataAnalytics/reducer";
import dataFetchHomeReducer from "containers/DataFetch/UploadPage/reducer";
import cashITCBalanceReducer from "containers/DataFetch/CashITCPage/reducer";
import cashITCLedgerReducer from "containers/DataFetch/CashITCLedger/reducer";
import AnalyticsGSRT1VS3BReducer from "containers/Analytics/GSTR1vsGSTR3B/reducer";
import ReturnFillingReducer from "containers/Analytics/ReturnFilling/reducer";
import GSTR3BVSGSTR2AReducer from "containers/Analytics/GSTR3BvsGSTR2A-2B/reducer";
import EWayBillRecoReducer from "containers/Analytics/EWayBillReco/reducer";
import RCMLiabilityReducer from "containers/Analytics/RCMLiability/reducer";
import TurnOverReducer from "containers/Analytics/TurnOverAnalysis/reducer";
import HSNAnalysisReducer from "containers/Analytics/HSNAnalysis/reducer";
import HSNAnalysisInwardReducer from "containers/Analytics/HSNAnalysisInward/reducer";
import TaxDischargedAnalysisReducer from "containers/Analytics/TaxDischargedAnalysis/reducer";
import ITCAnalysisReducer from "containers/Analytics/ITCAnalysis/reducer";
import LedgerBalanceAnalysisReducer from "containers/Analytics/LedgerBalanceAnalysis/reducer";
import CreditNoteAnalysisReducer from "containers/Analytics/CreditNoteAnalysis/reducer";
import SidebarReducer from "components/SideBar/reducer";
import gstinFilingReducer from "components/Modals/GstinFilingModal/reducer";
import changePassword from "containers/ChangePassword/reducer";
// import { connectRouter } from "connected-react-router";
import history from "utils/history";
import itc04PrepareReducer from './containers/ITC-04/PrepareReturn/reducer';
import itc04FileReturnReducer from './containers/ITC-04/FileReturn/reducer';
import itc04AnalyticsReducer from './containers/ITC-04/Analytics/reducer';
import itc04UploadReducer from "containers/ITC-04/DataUpload/reducer";
import itc04ViewReducer from "containers/ITC-04/ViewData/reducer";
import itc04Reducer from "containers/ITC-04/reducer";
import gstr2xCommonReducer from "containers/gstr2X/reducer";
import gstr2xPrepareReducer from "containers/gstr2X/PrepareData/reducer";
import gstr2xSaveReducer from "containers/gstr2X/SaveData/reducer";
import gstr2xFileReducer from "containers/gstr2X/File2X/reducer";
import getPresignedUrl from 'containers/Tutorial/reducer'
import gstr1NewCommonReducer from "containers/gstr1New/reducer";
import gstr1NewUploadReducer from "containers/gstr1New/DataUpload/reducer";
import gstr1NewFetchAndReconcileReducer from "containers/gstr1New/Fetch&Reconcile/reducer";
import gstr1NewViewReducer from "containers/gstr1New/ViewData/reducer";
import gstr1NewSaveReducer from "containers/gstr1New/Save/reducer";
import imsCommonReducer from 'containers/InvoiceMgmtSystem/reducer';
import imsPrepareReducer from 'containers/InvoiceMgmtSystem/Prepare/reducer';
import imsSaveReducer from 'containers/InvoiceMgmtSystem/Save/reducer';
import gstr1NewFileReducer from 'containers/gstr1New/File/reducer';
// Einvoice New Reducers
import EinvUploadReducerNew from 'containers/New_Einvoice/DataUpload/reducer';
import EinvFailedReducerNew from 'containers/New_Einvoice/FailedInvoices/reducer';
import EwayBillReducerNew from "containers/New_Einvoice/EwayBill/reducer";
import EinvReducerNew from "containers/New_Einvoice/Einvoice/reducer";
import ewbRecoFetchReducer from "containers/ewaybill_reco/Fetch/reducer";
import ewbRecoReconcilationReducer from "containers/ewaybill_reco/Reconcilation/reducer";
import getPresignedUrlManual from 'containers/Manual/reducer'
import gstr9NewDataUploadReducer from "containers/GSTR_9_New/DataUpload/reducer";
import gstr9NewCommonReducer from "containers/GSTR_9_New/common/reducer";
import gstr9cNewCommonReducer from "containers/GSTR9C_New/common/reducer";
import gstr9NewFetchReconcileReducer from "containers/GSTR_9_New/FetchReconcile/reducer";
import gstr9NewViewPrepareReducer from "containers/GSTR_9_New/ViewPrepare/reducer";
import gstr9NewSaveReducer from "containers/GSTR_9_New/Save/reducer";
import gstr9CNewFetchReducer from "containers/GSTR9C_New/Fetch/reducer";
import gstr9CNewPrepareReducer from "containers/GSTR9C_New/Prepare/reducer";
import gstr9CNewSaveReducer from "containers/GSTR9C_New/Save/reducer";

// IMS Reco Reducers
import imsRecoUploadReducer from "containers/ImsReco/DataUpload/reducer";
import imsRecoViewReducer from "containers/ImsReco/View/reducer";
import imsRecoCommonReducer from 'containers/ImsReco/reducer';
import imsRecoOutwardReducer from 'containers/ImsReco/Outward/reducer';
import imsRecoFetchReducer from 'containers/ImsReco/Fetch/reducer';
import imsRecoSaveReducer from 'containers/ImsReco/Save/reducer';
import imsRecoReconciliationReducer from 'containers/ImsReco/Reco/reducer';
// GSTR-2A/2B reco enhancement Reducers
import gstr2a2bNewCommonReducer from 'containers/gstr2a2bNewEnhancement/reducer';
import gstr2a2bNewRecoReducer from "containers/gstr2a2bNewEnhancement/Reconciliation/reducer";
import gstr2a2bNewDataUploadReducer from 'containers/gstr2a2bNewEnhancement/DataUpload/reducer';
import gstr2a2bNewViewReducer from 'containers/gstr2a2bNewEnhancement/View/reducer';
import gstr2a2bNewFetchReducer from 'containers/gstr2a2bNewEnhancement/Fetch/reducer';
import gstr2a2bNewITCReducer from 'containers/gstr2a2bNewEnhancement/ITCregister/reducer';

// Notes reducer
import notesReducer from "containers/Notes_module/Notes/reducer";
// Notice reducer
import noticeReducer from 'containers/Notice/Notice/reducer';
import emailMasterReducer from 'containers/Notice/EmailMaster/reducer';
import emailConfigReducer from "containers/Notice/EmailConfig/reducer";

import floatingChatReducer from "components/FloatingChat/reducer";

import templateMappingReducer from "containers/Template_Mapping/reducer";

import chatBotReducer from "containers/ChatBot/reducer";

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export default combineReducers({
  form: formReducer,
  gstr9CNewFetchReducer,
  gstr9CNewPrepareReducer,
  gstr9CNewSaveReducer,
  gstr9NewDataUpload: gstr9NewDataUploadReducer,
  gstr9NewCommon: gstr9NewCommonReducer,
  gstr9cNewCommon: gstr9cNewCommonReducer,
  gstr9NewFetchReconcile: gstr9NewFetchReconcileReducer,
  gstr9NewViewPrepare: gstr9NewViewPrepareReducer,
  gstr9NewSave: gstr9NewSaveReducer,
  ewbRecoReconcilationReducer,
  ewbRecoFetchReducer,
  gstr1NewUploadReducer,
  gstr1NewCommonReducer,
  gstr1NewViewReducer,
  gstr1NewFetchAndReconcileReducer,
  gstr1NewSaveReducer,
  gstr1NewFileReducer,
  gstinFilingReducer,
  gstr6UploadReducer,
  gstr6TabReducer,
  gstr6ISDDetailsReducer,
  gstr6ViewReducer,
  gstr6aReducer,
  gstr6CommonReducer,
  gstr3bCommonReducer,
  itc04UploadReducer,
  itc04ViewReducer,
  itc04PrepareReducer,
  itc04FileReturnReducer,
  itc04AnalyticsReducer,
  itc04Reducer,
  gstr2xCommonReducer,
  gstr2xPrepareReducer,
  gstr2xSaveReducer,
  gstr2xFileReducer,
  adminAPIReportReducer,
  manageGroupsReducer,
  gstr7CashBalanceReducer,
  gstr7FileDataReducer,
  gstr8UploadReducer,
  gstr8CashBalanceReducer,
  gstr8FileDataReducer,
  gstr8PrepareDataReducer,
  adminGSTINReportReducer,
  adminReportReducer,
  changePassword,
  landingReducer,
  invoiceReducer,
  gstinUploadReducer,
  trackReturnReducer,
  vendorMasterReducer,
  uploadReducer,
  uploadB2CReducer,
  uploadEInvoiceReducer,
  B2CuploadReducer,
  loginReducer,
  profileReducer,
  failedReducer,
  processedReducer,
  consolidateReducer,
  progressReducer,
  reportsReducer,
  logoutReducer,
  uploadedDataReducer,
  uploadedDataReducergstr9,
  prepareReducergstr9c,
  saveReducergstr9c,
  failedAnx1Reducer,
  dataFetchReducer,
  reconciliationReducer,
  scheduleReducer,
  ewaybillReducer,
  uploadEwayBillReducer,
  ewayBillGetReducer,
  consolidateGetReducer,
  ewayBillGetCallReducer,
  previewAndSubmitReducer,
  saveGstr1Reducer,
  saveGstr9Reducer,
  previewAndSubmitR3BReducer,
  summaryReducer,
  gatr2aFileProgressReducer,
  gatr2aPendinInvoicesReducer,
  // gatr2aPurchaseSummaryReducer,
  // gatr2bUpdateReducer,
  gstr1UploadReducer,
  gstr7UploadReducer,
  gstr7SummaryReducer,
  gstr1ProgressReducer,
  // gstr1InvoiceProgressReducer,
  gstr3bProgressReducer,
  SavePageGSTR3BReducer,
  gstr3bFileProgressReducer,
  userManagementReducer,
  managePincodeReducer,
  manageHsncodeReducer,
  userModuleReducer,
  profileManagementReducer,
  manageModuleReducer,
  managePassInvReducer,
  manageCompanyReducer,
  managePartnerReducer,
  uploadGstr3bReducer,
  uploadGstr9Reducer,
  gstrSupplierInfoReducer,
  gstr2aUploadReducer,
  // dataAnalyticsReducer,
  dataFetchHomeReducer,
  cashITCBalanceReducer,
  cashITCLedgerReducer,
  AnalyticsGSRT1VS3BReducer,
  ReturnFillingReducer,
  GSTR3BVSGSTR2AReducer,
  EWayBillRecoReducer,
  RCMLiabilityReducer,
  TurnOverReducer,
  HSNAnalysisReducer,
  HSNAnalysisInwardReducer,
  TaxDischargedAnalysisReducer,
  ITCAnalysisReducer,
  CreditNoteAnalysisReducer,
  LedgerBalanceAnalysisReducer,
  newB2CInvoiceReducer,
  SidebarReducer,
  getPresignedUrl,
  loadingBar: loadingBarReducer,
  imsCommonReducer,
  imsPrepareReducer,
  imsSaveReducer,
  EinvUploadReducerNew,
EinvFailedReducerNew,
EwayBillReducerNew,
EinvReducerNew,
getPresignedUrlManual,
  // router: connectRouter(history),
  imsRecoUploadReducer,
  imsRecoViewReducer,
  imsRecoCommonReducer,
  imsRecoOutwardReducer,
  imsRecoFetchReducer,
  imsRecoSaveReducer,
  imsRecoReconciliationReducer,
  gstr2a2bNewCommonReducer,
  gstr2a2bNewRecoReducer,
  gstr2a2bNewDataUploadReducer,
  gstr2a2bNewViewReducer,
  gstr2a2bNewFetchReducer,
  gstr2a2bNewITCReducer,
  notesReducer,
  noticeReducer,
  emailMasterReducer,
  emailConfigReducer,
  floatingChat: floatingChatReducer,
  templateMappingReducer,
  chatBotReducer

});

// export default function createReducer(injectedReducers = {}) {
//   const rootReducer = combineReducers({
//     form: formReducer,
//     landingReducer,
//     invoiceReducer,
//     gstinUploadReducer,
//     trackReturnReducer,
//     uploadReducer,
//     uploadB2CReducer,
//     newUploadB2CReducer,
//     loginReducer,
//     profileReducer,
//     failedReducer,
//     processedReducer,
//     consolidateReducer,
//     progressReducer,
//     reportsReducer,
//     logoutReducer,
//     uploadedDataReducer,
//     uploadedDataReducergstr9,
//     failedAnx1Reducer,
//     dataFetchReducer,
//     reconciliationReducer,
//     scheduleReducer,
//     ewaybillReducer,
//     uploadEwayBillReducer,
//     ewayBillGetReducer,
//     consolidateGetReducer,
//     ewayBillGetCallReducer,
//     previewAndSubmitReducer,
//     saveGstr1Reducer,
//     saveGstr9Reducer,
//     previewAndSubmitR3BReducer,
//     summaryReducer,
//     gatr2aFileProgressReducer,
//     gatr2aPendinInvoicesReducer,
//     gatr2aPurchaseSummaryReducer,
//     gatr2bUpdateReducer,
//     gstr1UploadReducer,
//     gstr1ProgressReducer,
//     // gstr1InvoiceProgressReducer,
//     gstr3bProgressReducer,
//     gstr3bFileProgressReducer,
//     userManagementReducer,
//     managePincodeReducer,
//     manageHsncodeReducer,
//     userModuleReducer,
//     profileManagementReducer,
//     manageModuleReducer,
//     manageCompanyReducer,
//     uploadGstr3bReducer,
//     uploadGstr9Reducer,
//     gstrSupplierInfoReducer,
//     gstr2aUploadReducer,
//     dataAnalyticsReducer,
//     dataFetchHomeReducer,
//     cashITCBalanceReducer,
//     cashITCLedgerReducer,
//     AnalyticsGSRT1VS3BReducer,
//     ReturnFillingReducer,
//     GSTR3BVSGSTR2AReducer,
//     EWayBillRecoReducer,
//     RCMLiabilityReducer,
//     TurnOverReducer,
//     HSNAnalysisReducer,
//     HSNAnalysisInwardReducer,
//     TaxDischargedAnalysisReducer,
//     ITCAnalysisReducer,
//     CreditNoteAnalysisReducer,
//     LedgerBalanceAnalysisReducer,
//     loadingBar: loadingBarReducer,
//     ...injectedReducers,
//   });

//   return rootReducer;
// }
